import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { templateKeys } from '../queries/keys';
import { templatePaths } from '../queries/paths';

// TSS vite/03 — server-state hooks para plantillas de notificación
// (api-reference/admin-notifications.md). Permiso notifications:read (lectura) /
// notifications:write (mutación). No hay GET por :code → el detalle se resuelve
// desde la lista (ver forms/edit.jsx).

export function useTemplatesList(filters) {
    return useQuery({
        queryKey: templateKeys.list(filters),
        queryFn:  ({ signal }) => api.get(templatePaths.list(), { params: filters, signal }).then(r => r.data),
        placeholderData: (prev) => prev,
    });
}

export function useCreateTemplate() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(templatePaths.list(), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: templateKeys.all }),
    });
}

export function useUpdateTemplate(code) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.patch(templatePaths.detail(code), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: templateKeys.all }),
    });
}

// POST /admin/notification-templates/:code/test-send — envía la plantilla a un
// `to` dado. Sin Twilio configurado el backend cae a `log`. No invalida caché.
export function useTestSendTemplate(code) {
    return useMutation({
        mutationFn: (payload) => api.post(templatePaths.testSend(code), payload).then(r => r.data),
    });
}
